// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PartitionOutlinedSvg from "@ant-design/icons-svg/es/asn/PartitionOutlined";
import AntdIcon from '../components/AntdIcon';

var PartitionOutlined = function PartitionOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PartitionOutlinedSvg
  }));
};

PartitionOutlined.displayName = 'PartitionOutlined';
export default React.forwardRef(PartitionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PartitionOutlined.js
// module id = 1537
// module chunks = 0